import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Match } from 'found';
import { StoreType } from '../reducers';
import { selectCuratedCollections } from '../reducers/collections.selectors';
import { CollectionProperties } from '../types/AppContent';
import { AsyncActionStatus } from '../actions/common.actionTypes';
import CuratedCollections from '../components/CuratedCollections';

interface StateProps {
  curatedCollections: CollectionProperties[];
  collectionStatus: AsyncActionStatus;
}

type CuratedCollectionListPageProps = StateProps & Match;

const CuratedCollectionListPage: React.FC<CuratedCollectionListPageProps> = ({
  curatedCollections,
  collectionStatus,
}) => {
 
  return (
    <CuratedCollections
      curatedCollections={curatedCollections}
      collectionsStatus={collectionStatus}
    /> 
  );
};

const mapState = (state: StoreType): StateProps => ({
  curatedCollections: selectCuratedCollections(state),
  collectionStatus: state.collections.curated.status,
});

export default compose<React.FC<Record<string,never>>>(
  connect(mapState),
)(CuratedCollectionListPage);
